import { IIndexable } from "@customtypes/common";

export const iconMapping: IIndexable = {
  ledger: "/assets/images/partners/ecosystems/ledger.svg",
  pantera: "/assets/images/partners/institutions/pantera.svg",
  coinbase_ventures:
    "/assets/images/partners/institutions/coinbase-ventures.svg",
  jump_capital: "/assets/images/partners/institutions/jump-capital.svg",
  blockchain: "/assets/images/partners/institutions/blockchain-com.svg",
  true_ventures: "/assets/images/partners/institutions/true-ventures.svg",
};
